<template>
  <div v-if="isAvailable === 0"></div>
  <div
    v-else
    class="entry"
    :style="{
      height: vHeight + 'px',
    }"
  >
    <img
      :src="bgimg"
      width="100%"
      height="auto"
      style="position: fixed; top: 0; left: 0"
      alt=""
    />
    <div>
      <div class="dh_btn" :class="vHeight <= 680 ? 'dh_btn2' : ''" @click="toPage(2)">
        开始兑换
      </div>
      <div class="dhjl" :class="vHeight <= 680 ? 'dhjl2' : ''" @click="toPage(1)">
        兑换记录
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
export default {
  name: "entry",
  data() {
    return {
      isPC: false,
      bgimg: "",
      vHeight: 0,
      isAvailable: 0, // 0: 无效; 1: 有效
    };
  },
  created() {
    // let vh = window.innerHeight;
    // this.vHeight = vh;
    // console.log("@@", navigator.userAgent);
  },

  mounted() {
    const { firstBrandId, projectIntegralId, isPC, redeemCode } = this.$route.query;
    this.getviId();

    localStorage.setItem("firstBrandId", firstBrandId);
    localStorage.setItem("projectIntegralId", projectIntegralId);
    localStorage.setItem("redeemCode", redeemCode ?? "");
    this.isPC = isPC === "true";

    this.getImg({ firstBrandId, projectIntegralId });

    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //获取设备id
    async getviId() {
      const fp = await FingerprintJS.load({ screen_resolution: true });

      const result = await fp.get();

      const visitorId = result.visitorId;
      localStorage.setItem("deviceId", visitorId);
    },
    // 获取背景图片
    getImg: function ({ firstBrandId, projectIntegralId }) {
      console.log(`firstBrandId`, firstBrandId, projectIntegralId);
      this.$store
        .dispatch({
          type: "entry/backgroundImage",
          payload: {
            firstBrandId,
            projectIntegralId,
          },
        })
        .then((res) => {
          const {
            fillBankCard,
            specifyBankSix,
            specifyBankSixText,
            isAvailable = 1,
          } = res;
          const bankCardInfo = {
            fillBankCard, // 0 关闭，1开启
            specifyBankSix, // 0关闭，1开启
            specifyBankSixText,
          };

          this.bgimg = res.backImages;
          localStorage.setItem("bankCardInfo", JSON.stringify(bankCardInfo));

          if (isAvailable === 0) {
            Toast("活动关闭，链接已失效");
          }
          this.isAvailable = isAvailable;
        });
    },
    /**
     * 跳转，
     * routerType 1：兑换记录 2:开始兑换
     */
    toPage: function (routerType) {
      if (this.isPC) return;

      const orouter = {
        1: {
          path: "/user",
        },
        2: {
          path: "/start",
        },
      };

      this.$router.push(orouter[routerType]);
    },
    handleResize() {
      // 在这里根据窗口大小进行操作，例如自动调整内容的大小
      // 你可以设置数据属性来记录窗口的当前状态
      let vh = window.innerHeight;
      // 适配微信企业微信
      if (navigator.userAgent.indexOf("wxwork") != -1) {
        vh += 5;
      }
      this.vHeight = vh;
    },
  },
};
</script>
<style lang="scss">
.entry {
  position: relative;
  width: 100%;
  overflow: hidden;

  .dh_btn {
    position: absolute;
    left: 50%;
    bottom: 91px;
    margin-left: -59px;

    width: 118px;
    height: 40px;
    background: #41ba9e;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #f7f0dc;
  }

  .dhjl {
    position: absolute;
    bottom: 39px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #41ba9e;
  }
  .dh_btn2 {
    bottom: 45px;
  }
  .dhjl2 {
    bottom: 20px;
  }
}
</style>
